export const getTheme = state => state.darkModeReducer.isDarkModeEnabled;
